import React, { useEffect, useState } from 'react'

import AcoountUserComp from '../../Components/addNewUserComp/AcoountUserComp';
import Myprofile from '../myprofile/Myprofile';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getAllAccountUserThunk, setAccountUserPage } from '../../../../Website/redux/AccountUserSlice';
import CatPagination from '../../../../Website/utils/Pagination';

const Accountusers = () => {

    const { loading, refresh, users, page } = useSelector((state) => state.accountUser)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [limit, setLimit] = useState(25)
    const [order, setOrder] = useState('asc')
    const [sortBy, setSortyBy] = useState('createdAt');

    const userData = users?.data
    const totalPages = users?.totalPages
    const totalItems = users?.totalItems
    const itemsPerPage = users?.limit

    // calculate start & end of items -------------------
    const start = (page - 1) * limit + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * limit + limit;

    useEffect(() => {
        dispatch(getAllAccountUserThunk(`?page=${page}&limit=${limit}&sortBy=${sortBy}&order=${order}`))
    }, [refresh,page,limit,sortBy,order])


    const handleOpenMenu = (sort) => {
        setSortyBy(sort)
        setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    // console.log(users);

    return (
        <>
            <Myprofile>
                <AcoountUserComp
                    userData={userData}
                    page={page}
                    setPage={setAccountUserPage}
                    itemsPerPage={itemsPerPage}
                    totalItems={totalItems}
                    totalPages={totalPages}
                    start={start}
                    end={end}
                  
                    handleOpenMenu={handleOpenMenu}
                />

            </Myprofile>

        </>
    )
}

export default Accountusers